"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkXKXSN756cjs = require('./chunk-XKXSN756.cjs');


var _chunkR5F56AVKcjs = require('./chunk-R5F56AVK.cjs');


var _chunkFXL7SAQJcjs = require('./chunk-FXL7SAQJ.cjs');


var _chunkWF6EZ2CWcjs = require('./chunk-WF6EZ2CW.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/router/BaseRouterV2_2.ts
var BaseRouterV2_2 = (_class = class extends _chunkFXL7SAQJcjs.BaseRouterV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
  async getPool(provider, params) {
    const poolAddress = await this.getPoolAddressByJettonMinters(
      provider,
      params
    );
    return _chunkXKXSN756cjs.BasePoolV2_2.create(poolAddress);
  }
  async getVault(provider, params) {
    const tokenMinter = provider.open(_chunkWF6EZ2CWcjs.JettonMinter.create(params.tokenMinter));
    const vaultAddress = await this.getVaultAddress(provider, {
      user: params.user,
      tokenWallet: await tokenMinter.getWalletAddress(this.address)
    });
    return _chunkR5F56AVKcjs.VaultV2_2.create(vaultAddress);
  }
}, _class.__initStatic(), _class);



exports.BaseRouterV2_2 = BaseRouterV2_2;
//# sourceMappingURL=chunk-V226MHMG.cjs.map